module.exports = __webpack_public_path__ + "img/racecourse-fairview-turf-800.77e3f705.svg";